import apiClient from '@/services/axios'
import config from '@/configs'

// * campaigns functions
// get campaigns by query
export async function fetchCampaigns(query) {
  return apiClient
    .post(`${config.api.marketing.campaigns}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[Marketing/Campaigns API]:', err))
}

// get a campaign by id
export async function fetchCampaign(id) {
  return apiClient
    .get(`${config.api.marketing.campaigns}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[Marketing/Campaigns API]:', err))
}

// create a new campaign
export async function createCampaign(campaign) {
  return apiClient
    .post(config.api.marketing.campaigns, campaign)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[Marketing/Campaigns API]:', err))
}

// update a campaign
export async function updateCampaign(campaign) {
  return apiClient
    .put(config.api.marketing.campaigns, campaign)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[Marketing/Campaigns API]:', err))
}
